import * as React from "react";
import { useEffect, useState } from "react";
import { ContextStore } from "../../../../../../../../react-core/Flux/Variables";
import { Lightbox } from "../../../../../../../../react-core/Html/Components/Lightbox";
import { SelectEditor } from "../../../../../../../../react-core/Html/SelectEditor";
import { TextBoxEditor } from "../../../../../../../../react-core/Html/TextBoxEditor";
import { AlphanumericWithSpace } from "../../../../../../../../react-core/Html/Validation/RegExPatterns";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { ContextType } from "../../../../../../../../Wrap/Constants/Enums/ContextType";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { HierarchyLevelName } from "../../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { UserClaim } from "../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { ClientAccount } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { setActionMenuParams } from "../../../../../../../DLU/DLUHelper";
import { HierarchyIdHelper } from "../../../../../../../Shared/Common/HierarchyIdHelper";
import { Permission } from "../../../../../../../Shared/Permission/Permission";
import { checkPermission } from "../../../../../../../Shared/Permission/PermissionHelper";
import { Table } from "../../../../../../../Shared/Table/Table";
import { ValidatorContents } from "../../../../../../Common/ValidatorHelper";
import { SubaccountSideMenuMap } from "../../../../../CustomNavigation/Entities/SubaccountSideMenuMap";
import { accountStatusMap } from "../../../../ClientSearch/Resource/Content";
import { Contents } from "../../Transactions/Resource/Contents";
import { AccountAllowedStatusAction } from "../Action/AccountAllowedStatusAction";
import { ProductOverviewProductInformationAction } from "../Action/ProductOverviewProductInformationAction";
import { ProductOverviewSippPensionInformationAction } from "../Action/ProductOverviewSippPensionInformationAction";
import { ProductOverviewSippBeneficiariesAction } from "../Action/ProductOverviewSippBeneficiariesAction";
import { ProductOverviewSippTaxInformationAction } from "../Action/ProductOverviewSippTaxInformationAction";
import SIPPIncormation from "./SIPPInformation";
import ProductOverviewInformation from "./ProductOverViewInformation";

interface IProductOverviewProductInformationProps {
    subAccountHierarchyId: string;
    selectedProduct?: SubAccountType;
    headaccount: ClientAccount;
}

export const ProductOverviewProductInformation = (props: IProductOverviewProductInformationProps) => {
    const subAccount = props.headaccount.SubAccounts.find((ele) => ele.HierarchyId == props.subAccountHierarchyId);
    const SIPPTYPE = 16;
    const [data, setData] = useState(null);
    const [pensionInfo, setPensionInfo] = useState(null);
    const [showSIPP, setshowSIPP] = useState(false);
    const [taxInfo, setTaxInfo] = useState(null);
    const [beneficiariesInfo, setBeneficiariesInfo] = useState(null);
    const [name, setName] = useState<string>(
        subAccount?.ProductDisplayName.startsWith("PP - ")
            ? subAccount?.ProductDisplayName?.replace("PP - ", "")
            : subAccount?.ProductDisplayName
    );

    const [selectedStatus, setSelectedStatus] = useState(null);
    const [isValid, setIsValid] = useState(true);
    const customerid = HierarchyIdHelper.generateHierarchyId(ContextStore.getUrlParamsHierarchyId(ContextType.Customer))
        .entityId;

    const showSIPPOverviewInformation = (value: boolean) => {
        setshowSIPP(props?.selectedProduct == SubAccountType.Npr || props?.selectedProduct === SubAccountType.JuniorSipp);
    };

    useEffect(() => {
        ProductOverviewProductInformationAction.getProductInformation(props.subAccountHierarchyId, (data) => {
            setData(data);
        });

        ProductOverviewSippBeneficiariesAction.get(props.subAccountHierarchyId, (data) => {
            setBeneficiariesInfo(data);
        });

        showSIPPOverviewInformation(true);

        if (props?.selectedProduct == SubAccountType.Npr || props?.selectedProduct === SubAccountType.JuniorSipp) {
            ProductOverviewSippPensionInformationAction.get(props.subAccountHierarchyId, (data) => {
                setPensionInfo(data);
            });

            ProductOverviewSippTaxInformationAction.get(props.subAccountHierarchyId, (data) => {
                setTaxInfo(data);
            });
        }
    }, [props.subAccountHierarchyId]);

    return (
        <>            
            {!showSIPP && (
                <ProductOverviewInformation
                    setSelectedStatus={setSelectedStatus}
                    selectedStatus={selectedStatus}
                    isValid={isValid}
                    setData={setData}
                    data={data}
                    name={name}
                    setIsValid={setIsValid}
                    setName={setName}
                    subAccount={subAccount}
                    customerId={customerid}
                    headAccount={props.headaccount}
                />
            )}            

            {showSIPP && (
                <SIPPIncormation
                    setSelectedStatus={setSelectedStatus}
                    selectedStatus={selectedStatus}
                    isValid={isValid}
                    setIsValid={setIsValid}
                    pensionInfo={pensionInfo}
                    setData={setData}
                    data={data}
                    taxInfo={taxInfo}
                    beneficiariesInfo={beneficiariesInfo}
                    subAccount={subAccount}
                    customerid={customerid}
                    headaccount={props.headaccount}
                />
            )}
        </>
    );
};
